export const QUOTATION_VALIDITY_DAYS = 10;
export const QUOTATION_EXPIRING_SOON_BEFORE_DAYS = 3;

export enum QuotationStatus {
    Sent = "79774880-d8cf-42ce-8d2a-2bcaffa59626",
    Requested = "112c2787-6e1a-44c8-8c1e-08aa6fe2b843",
    Expiring_Soon = "13b714b1-6427-449f-9ecc-a48275495b2e",
    Expired = "8110a358-6580-462d-a350-362451eb354f",
}

export const quotationStatusMap: Record<string, "requested" | "sent" | "expiring-soon" | "expired"> = {
    [QuotationStatus.Sent]: "sent",
    [QuotationStatus.Requested]: "requested",
    [QuotationStatus.Expiring_Soon]: "expiring-soon",
    [QuotationStatus.Expired]: "expired",
};

export enum DiscountType {
    PERCENTAGE = "eaada740-62bc-4f78-b07f-5962613ff47d",
    FLAT = "bdea3256-677d-48e2-9242-5995c3256f5e",
}
